(function () {
  'use strict';
  if (window.__ANATOMY_AB__) return;
  window.__ANATOMY_AB__ = true;

  var assignments = window.AnatomyExperimentAssignments || {};
  var exposureKey = 'anatomy_experiment_exposures_v1';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function readSession() {
    try {
      return JSON.parse(window.sessionStorage.getItem(exposureKey) || '{}') || {};
    }
    catch (error) {
      return {};
    }
  }

  function writeSession(value) {
    try {
      window.sessionStorage.setItem(exposureKey, JSON.stringify(value));
    }
    catch (error) {}
  }

  function properties(assignment, exposedAt) {
    return {
      schema_version: 'funnel_context_v1',
      event_name_normalized: exposedAt ? 'experiment_exposed' : 'experiment_assigned',
      funnel_stage: 6,
      experiment_id: assignment.experiment_id,
      experiment_version: assignment.version,
      experiment_phase: assignment.phase,
      experiment_variant: assignment.variant,
      experiment_bucket: assignment.bucket,
      experiment_assigned_at: assignment.assigned_at,
      experiment_exposed_at: exposedAt || '',
      experiment_is_qa_forced: !!assignment.is_qa_forced,
      experiment_analysis_eligible: !assignment.is_qa_forced
    };
  }

  function capture(name, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(name, props);
        return true;
      }
    }
    catch (error) {}
    return false;
  }

  function registerAssignments() {
    if (!window.posthog || typeof window.posthog.register !== 'function') return false;
    Object.keys(assignments).forEach(function (id) {
      var assignment = assignments[id];
      var props = properties(assignment);
      window.posthog.register(props);
      var assignedKey = 'assigned:' + id + ':' + assignment.version + ':' + assignment.variant;
      var seen = readSession();
      if (!seen[assignedKey]) {
        capture('an_experiment_assigned', props);
        seen[assignedKey] = new Date().toISOString();
        writeSession(seen);
      }
    });
    return true;
  }

  function registerLegacyDestinationTest() {
    var arm = getCookie('ab_arm');
    if (arm !== 'matched' && arm !== 'collection') return;
    if (!window.posthog || typeof window.posthog.register !== 'function') return;
    window.posthog.register({
      lp_ab: arm,
      lp_dest: getCookie('ab_dest') || '',
      lp_test: 'lp_dest_v1'
    });
  }

  function bindExposure() {
    if (!('IntersectionObserver' in window)) return;
    var seen = readSession();
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.45) return;
        var id = entry.target.getAttribute('data-an-experiment-surface') || '';
        var assignment = assignments[id];
        if (!assignment) return;
        var key = 'exposed:' + id + ':' + assignment.version + ':' + assignment.variant;
        if (seen[key]) {
          observer.unobserve(entry.target);
          return;
        }
        var exposedAt = new Date().toISOString();
        capture('an_experiment_exposed', properties(assignment, exposedAt));
        seen[key] = exposedAt;
        writeSession(seen);
        observer.unobserve(entry.target);
      });
    }, { threshold: [0.45] });

    document.querySelectorAll('[data-an-experiment-surface]').forEach(function (element) {
      observer.observe(element);
    });
  }

  function bindTreatmentRail() {
    var rail = document.querySelector('[data-an-transaction-rail-primary]');
    var sticky = document.querySelector('[data-an-transaction-rail-sticky]');
    if (!rail || !sticky || !('IntersectionObserver' in window)) return;
    if (!document.documentElement.classList.contains('an-exp-heat-first-viewport-v1-treatment')) {
      sticky.hidden = true;
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
      });
    }, { threshold: [0, 0.15] });
    observer.observe(rail);
  }

  window.AnatomyExperiments = {
    assignments: assignments,
    getCartAttributes: function () {
      var output = {};
      Object.keys(assignments).forEach(function (id) {
        var assignment = assignments[id];
        output.experiment_id = assignment.experiment_id;
        output.experiment_version = assignment.version;
        output.experiment_phase = assignment.phase;
        output.experiment_variant = assignment.variant;
        output.experiment_bucket = assignment.bucket;
        output.experiment_assigned_at = assignment.assigned_at;
        output.experiment_is_qa_forced = assignment.is_qa_forced ? 'true' : 'false';
      });
      return output;
    }
  };

  function initialize() {
    registerLegacyDestinationTest();
    if (!registerAssignments()) return false;
    bindExposure();
    bindTreatmentRail();
    return true;
  }

  if (!initialize()) {
    var poll = window.setInterval(function () {
      if (initialize()) window.clearInterval(poll);
    }, 250);
    window.setTimeout(function () { window.clearInterval(poll); }, 10000);
  }
})();
